/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME = "Zählerstand Zähler ablesen - Eure Stadtwerke Wilster";
export const APP_SHORT_NAME = "Ableseportal";
export const APP_DESCRIPTION =
    "Geben Sie uns Ihren Zählerstand einfach online durch!";
export const CLIENT_FULL = "Stadtwerke Wilster GmbH";
export const CLIENT_SHORT = "Stadtwerke Wilster";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://www.stadtwerke-wilster.de",
    privacy: "https://www.stadtwerke-wilster.de/datenschutz/",
    imprint: "https://www.stadtwerke-wilster.de/impressum/",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
